import React, { Fragment } from 'react';
import { Modal } from './Modal';
import { Button } from '../Button';
import { Text } from 'components/Text';
import './ModalSendEmail.scss';
/**
 * @component ModalSendEmail
 * @since 1.0.0
 * @hidden
 */
export function ModalSendEmail(props) {
    const { onClose, single, selectedName } = props;
    const footerActions = (React.createElement(Fragment, null,
        React.createElement(Button, { label: t('Cancel'), onPress: onClose, noPadding: true }),
        React.createElement("div", { className: "modal-send-email-button-container" },
            React.createElement(Button, { style: "primary", label: t('Confirm'), submit: true }))));
    return (React.createElement("div", { className: "modal-send-email" },
        React.createElement(Modal, { picto: "paper-plane", title: t('Send Email'), onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "modal-send-email-content" }, single ? (React.createElement(Text, { value: `${t('By clicking here, an email including a data update form will be sent to')} ${selectedName}.` })) : (React.createElement(Text, { value: t('By clicking here, an email including a data update form will be sent to your organizations.') }))))));
}
